import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDialog,
  MatSelect
} from "@angular/material";

import { IBranch } from "src/app/interfaces/branch";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import * as moment from "jalali-moment";
import { AccountService } from "src/app/services/http/business/account/account.service";
import { AccountSearchComponent } from "../account-search/account-search.component";
import { ChangePassDirectComponent } from "../change-pass-direct/change-pass-direct.component";
import { ProfileEditComponent } from "../profile-edit/profile-edit.component";
import { AccountDetailComponent } from "../account-detail/account-detail.component";
import { PayToPersonComponent } from "../pay-to-person/pay-to-person.component";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { PayToWalletPersonComponent } from "../pay-to-wallet-person/pay-to-wallet-person.component";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { IConfirm } from "src/app/interfaces/confirm";
import { SendSmsComponent } from "src/app/pages/management/send-sms/send-sms.component";


@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.css']
})
export class AccountListComponent implements OnInit {
  CompanyEncryptId: string;
  branchList: IBranch[];
  companyList: ICompany[];
  isOwner: boolean;
  hideTable: boolean = true;
  filter: any;

  displayedColumns: string[] = [
    'FullName',
    'LastEditor',
    'NationalCode',
    'PhoneNumber',
    'Email',
    'StatusName',
    'StatusFunction',
    'CreationDate',
    'function'
  ];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    private holdingService: HoldingService,
    public translate: TranslateService,
    private snackBar: SnackBarService,
    private branchService: BranchService,
    private accountService: AccountService

  ) { }

  ngOnInit() {
    this.checkOwner();
    this.dataSource.paginator = this.paginator;
    this.refresh();
    //this.test();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
    });
  }

  getColor(statusId) {
    switch (statusId) {
      case 121:
        return "custom-chips primary";
      case 120:
        return "custom-chips accent";
      case 122:
        return "custom-chips accent";
      case 123:
        return "custom-chips primary";
      case 124:
        return "custom-chips accent";
      case 125:
        return "custom-chips primary";
      case 127:
        return "custom-chips accent";
      case 129:
        return "custom-chips accent";
      case 130:
        return "custom-chips accent";
      default:
        return "custom-chips default";
    }
  }

  quaryParams = {
    StartDate: this.getDateOfThePreviousMonth(new Date()),
    EndDate: new Date()
  };

  getDateOfThePreviousMonth(dateTime: Date): string {
    const date = moment(dateTime.setMonth(dateTime.getMonth() - 1));
    return date.format('YYYY/MM/DD h:mm a');
  }

  changePass(data: any) {
    this.dialog
      .open(ChangePassDirectComponent, {
        width: '350px',
        data: data
      })
      .afterClosed()
      .subscribe(res => {
        console.log(res);
        this.filter = res
      });
  }

  payToPerson(data: any) {
    this.dialog
      .open(PayToPersonComponent, {
        width: '550px',
        data: data
      })
      .afterClosed()
      .subscribe(() => {
      });
  }

  PayToWalletPerson(data: any) {
    this.dialog
      .open(PayToWalletPersonComponent, {
        width: '550px',
        data: data
      })
      .afterClosed()
      .subscribe(() => {
      });
  }


  search() {
    this.dialog
      .open(AccountSearchComponent, {
        width: '300px',
        data: null
      })
      .afterClosed()
      .subscribe(res => {
        console.log(res);
        this.filter = res
        this.refresh();
      });
  }
  //open modal from edit profile user
  profileEdit(data: any) {
    this.dialog
      .open(ProfileEditComponent, {
        width: '800px',
        data: data
      })
      .afterClosed()
      .subscribe(() => {
        this.accountService.urerList(this.filter, this.paginator.pageIndex + 1, this.paginator.pageSize)
          .subscribe(res => {
            this.dataSource = new MatTableDataSource(res.DataList);
            this.paginator.length = res.Total;
          });
      });
  }

  //open modal from show details user
  details(data: any) {
    this.dialog
      .open(AccountDetailComponent, {
        width: '550px',
        data: data
      })
      .afterClosed()
      .subscribe(() => {
      });
  }

  sendSms(data) {
    this.dialog
      .open(SendSmsComponent, {
        width: '700px',
        data: {
          StudentNationalCode: data.NationalCode,
          StudentName: data.FullName,
          Mobile: data.PhoneNumber
        }
      });
  }

  activeUser(data: any) {
    let confirm: IConfirm = {
      accept: true,
      message: 'آیا از فعال سازی کاربر اطمینان دارید؟',
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "300px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          var command = {
            NationalCode: data.NationalCode,
            State: 1
          }
          this.accountService.userActivationByAdmin(command).subscribe(() => {
            this.snackBar.OpenSnackBar(
              'وضعیت کاربر با موفقیت ویرایش شد.',
              "ok",
              3000,
              SoundEnum.beep
            );
            this.accountService.urerList(this.filter, this.paginator.pageIndex + 1, this.paginator.pageSize)
              .subscribe(res => {
                this.dataSource = new MatTableDataSource(res.DataList);
                this.paginator.length = res.Total;
              });
          },
            () => {
              this.snackBar.OpenSnackBar(
                'خطا در تغییر وضعیت کاربر.',
                "ok",
                3000,
                SoundEnum.beep
              );
            }
          );
        }
      });
  }

  deActiveUser(data: any) {
    let confirm: IConfirm = {
      accept: true,
      message: 'آیا از مسدود سازی کاربر اطمینان دارید؟',
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "300px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          var command = {
            NationalCode: data.NationalCode,
            State: 3
          }
          this.accountService.userActivationByAdmin(command).subscribe(() => {
            this.snackBar.OpenSnackBar(
              'وضعیت کاربر با موفقیت ویرایش شد.',
              "ok",
              3000,
              SoundEnum.beep
            );
            this.accountService.urerList(this.filter, this.paginator.pageIndex + 1, this.paginator.pageSize)
              .subscribe(res => {
                this.dataSource = new MatTableDataSource(res.DataList);
                this.paginator.length = res.Total;
              });
          },
            () => {
              this.snackBar.OpenSnackBar(
                'خطا در تغییر وضعیت کاربر.',
                "ok",
                3000,
                SoundEnum.beep
              );
            }
          );
        }
      });



  }

  getBranchList() {
    this.branchService.listByLogin(0, 0).subscribe(res => {
      this.branchList = res.DataList;
    });
  }


  setCid(companyEncryptId: MatSelect) {
    this.dataSource = null;
    // if (this.isOwner)
    this.cidService.setCID(companyEncryptId.value);
    this.loadRegistration(companyEncryptId.value);
  }

  loadRegistration(companyEncryptId: string) {
    this.dataSource = null;
    this.CompanyEncryptId = companyEncryptId;
    this.filter = null;
    this.refresh();
  }

  refresh() {
    this.accountService.urerList(this.filter, 1, 10).subscribe(res => {

      console.log(res)
      this.hideTable = false;
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }
  paginatorEvent(event) {
    this.accountService.urerList(this.filter, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }


  // ngOnDestroy(): void {
  //   if (this.checkOwner) {
  //     this.bidService.setBID("");
  //   }
  // }

}
